import { render, staticRenderFns } from "./affLogin.vue?vue&type=template&id=3ca82a67"
import script from "./affLogin.vue?vue&type=script&lang=js"
export * from "./affLogin.vue?vue&type=script&lang=js"
import style0 from "./affLogin.vue?vue&type=style&index=0&id=3ca82a67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports